import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  useDisclosure,
  Box,
  Center,
  Text
} from '@chakra-ui/react'
import { FC } from 'react'

import useOptimizerDefault from '@hook/optimizer/use-optimizer-default'

const OptimizerConfigDefaultDelete: FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { deleteData, selected } = useOptimizerDefault()

  return (
    <>
      <Button
        fontSize={14}
        size="sm"
        colorScheme="red"
        variant="outline"
        transition="all ease .2s"
        onClick={onOpen}
      >
        Excluir
      </Button>
      <Modal
        isCentered
        isOpen={isOpen}
        onClose={onClose}
        scrollBehavior="inside"
        motionPreset="slideInBottom"
        colorScheme="white"
        size="lg"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalBody bg="white" pt={0} py={4}>
            <Box p={6}>
              <Text fontSize="3xl" align="center">
                Parametros Default
              </Text>
              <Text align="center" fontSize="sm">
                Você está prestes a excluir 1 registros. Esta ação é
                irreversível e os dados serão permanentemente removidos do
                sistema.
              </Text>
              <br></br>
              <Text align="center" fontSize="sm">
                Tem certeza de que deseja prosseguir com a exclusão?
              </Text>
            </Box>
            <Center>
              <Box p={2} alignItems="center" alignContent="center">
                <Button
                  colorScheme="green"
                  mr={3}
                  onClick={() => {
                    deleteData()
                    onClose()
                  }}
                  alignItems="center"
                >
                  Sim
                </Button>
                <Button colorScheme="red" mr={3} onClick={onClose}>
                  Não
                </Button>
              </Box>
            </Center>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}

export default OptimizerConfigDefaultDelete
